/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnableShipdayMon1 } from './EnableShipdayMon1';
import {
    EnableShipdayMon1FromJSON,
    EnableShipdayMon1FromJSONTyped,
    EnableShipdayMon1ToJSON,
    EnableShipdayMon1ToJSONTyped,
} from './EnableShipdayMon1';

/**
 * 
 * @export
 * @interface MstSupplierUpateBase
 */
export interface MstSupplierUpateBase {
    /**
     * 
     * @type {number}
     * @memberof MstSupplierUpateBase
     */
    companyId?: number | null;
    /**
     * 仕入先ID
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    orgSupplierId: string;
    /**
     * 
     * @type {number}
     * @memberof MstSupplierUpateBase
     */
    supplierCompanyId?: number | null;
    /**
     * 仕入先名
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    supplierName: string;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    transportOrgCenterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    supplierHojinNo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    supplierAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    supplierGln?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstSupplierUpateBase
     */
    minOrderQuantityOnce?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstSupplierUpateBase
     */
    orderLeadtime?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    orderLimitTime?: string | null;
    /**
     * 
     * @type {EnableShipdayMon1}
     * @memberof MstSupplierUpateBase
     */
    enableShipdayMon?: EnableShipdayMon1 | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableShipdayTue?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableShipdayWed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableShipdayThu?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableShipdayFri?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableShipdaySat?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableShipdaySun?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableOrderdayMon?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableOrderdayTue?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableOrderdayWed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableOrderdayThu?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableOrderdayFri?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableOrderdaySat?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    enableOrderdaySun?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    orderTiming?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    monthlyOrderLimitDay?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    monthlyOrderTarget?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MstSupplierUpateBase
     */
    enableSupplierShipday?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    remarks?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplierUpateBase
     */
    deleteFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstSupplierUpateBase
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstSupplierUpateBase
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    updateUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstSupplierUpateBase
     */
    deleteDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplierUpateBase
     */
    deleteUser?: string | null;
}

/**
 * Check if a given object implements the MstSupplierUpateBase interface.
 */
export function instanceOfMstSupplierUpateBase(value: object): value is MstSupplierUpateBase {
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('supplierName' in value) || value['supplierName'] === undefined) return false;
    return true;
}

export function MstSupplierUpateBaseFromJSON(json: any): MstSupplierUpateBase {
    return MstSupplierUpateBaseFromJSONTyped(json, false);
}

export function MstSupplierUpateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstSupplierUpateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'orgSupplierId': json['org_supplier_id'],
        'supplierCompanyId': json['supplier_company_id'] == null ? undefined : json['supplier_company_id'],
        'supplierName': json['supplier_name'],
        'transportOrgCenterId': json['transport_org_center_id'] == null ? undefined : json['transport_org_center_id'],
        'supplierHojinNo': json['supplier_hojin_no'] == null ? undefined : json['supplier_hojin_no'],
        'supplierAddress': json['supplier_address'] == null ? undefined : json['supplier_address'],
        'supplierGln': json['supplier_gln'] == null ? undefined : json['supplier_gln'],
        'minOrderQuantityOnce': json['min_order_quantity_once'] == null ? undefined : json['min_order_quantity_once'],
        'orderLeadtime': json['order_leadtime'] == null ? undefined : json['order_leadtime'],
        'orderLimitTime': json['order_limit_time'] == null ? undefined : json['order_limit_time'],
        'enableShipdayMon': json['enable_shipday_mon'] == null ? undefined : EnableShipdayMon1FromJSON(json['enable_shipday_mon']),
        'enableShipdayTue': json['enable_shipday_tue'] == null ? undefined : json['enable_shipday_tue'],
        'enableShipdayWed': json['enable_shipday_wed'] == null ? undefined : json['enable_shipday_wed'],
        'enableShipdayThu': json['enable_shipday_thu'] == null ? undefined : json['enable_shipday_thu'],
        'enableShipdayFri': json['enable_shipday_fri'] == null ? undefined : json['enable_shipday_fri'],
        'enableShipdaySat': json['enable_shipday_sat'] == null ? undefined : json['enable_shipday_sat'],
        'enableShipdaySun': json['enable_shipday_sun'] == null ? undefined : json['enable_shipday_sun'],
        'enableOrderdayMon': json['enable_orderday_mon'] == null ? undefined : json['enable_orderday_mon'],
        'enableOrderdayTue': json['enable_orderday_tue'] == null ? undefined : json['enable_orderday_tue'],
        'enableOrderdayWed': json['enable_orderday_wed'] == null ? undefined : json['enable_orderday_wed'],
        'enableOrderdayThu': json['enable_orderday_thu'] == null ? undefined : json['enable_orderday_thu'],
        'enableOrderdayFri': json['enable_orderday_fri'] == null ? undefined : json['enable_orderday_fri'],
        'enableOrderdaySat': json['enable_orderday_sat'] == null ? undefined : json['enable_orderday_sat'],
        'enableOrderdaySun': json['enable_orderday_sun'] == null ? undefined : json['enable_orderday_sun'],
        'orderTiming': json['order_timing'] == null ? undefined : json['order_timing'],
        'monthlyOrderLimitDay': json['monthly_order_limit_day'] == null ? undefined : json['monthly_order_limit_day'],
        'monthlyOrderTarget': json['monthly_order_target'] == null ? undefined : json['monthly_order_target'],
        'enableSupplierShipday': json['enable_supplier_shipday'] == null ? undefined : json['enable_supplier_shipday'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
        'deleteDatetime': json['delete_datetime'] == null ? undefined : (new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'] == null ? undefined : json['delete_user'],
    };
}

export function MstSupplierUpateBaseToJSON(json: any): MstSupplierUpateBase {
    return MstSupplierUpateBaseToJSONTyped(json, false);
}

export function MstSupplierUpateBaseToJSONTyped(value?: MstSupplierUpateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'org_supplier_id': value['orgSupplierId'],
        'supplier_company_id': value['supplierCompanyId'],
        'supplier_name': value['supplierName'],
        'transport_org_center_id': value['transportOrgCenterId'],
        'supplier_hojin_no': value['supplierHojinNo'],
        'supplier_address': value['supplierAddress'],
        'supplier_gln': value['supplierGln'],
        'min_order_quantity_once': value['minOrderQuantityOnce'],
        'order_leadtime': value['orderLeadtime'],
        'order_limit_time': value['orderLimitTime'],
        'enable_shipday_mon': EnableShipdayMon1ToJSON(value['enableShipdayMon']),
        'enable_shipday_tue': value['enableShipdayTue'],
        'enable_shipday_wed': value['enableShipdayWed'],
        'enable_shipday_thu': value['enableShipdayThu'],
        'enable_shipday_fri': value['enableShipdayFri'],
        'enable_shipday_sat': value['enableShipdaySat'],
        'enable_shipday_sun': value['enableShipdaySun'],
        'enable_orderday_mon': value['enableOrderdayMon'],
        'enable_orderday_tue': value['enableOrderdayTue'],
        'enable_orderday_wed': value['enableOrderdayWed'],
        'enable_orderday_thu': value['enableOrderdayThu'],
        'enable_orderday_fri': value['enableOrderdayFri'],
        'enable_orderday_sat': value['enableOrderdaySat'],
        'enable_orderday_sun': value['enableOrderdaySun'],
        'order_timing': value['orderTiming'],
        'monthly_order_limit_day': value['monthlyOrderLimitDay'],
        'monthly_order_target': value['monthlyOrderTarget'],
        'enable_supplier_shipday': value['enableSupplierShipday'],
        'remarks': value['remarks'],
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
    };
}

